module.exports = __webpack_public_path__ + "static/media/agc012.b19ca250.jpg";